<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousAir" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Air Freight Import Tracking</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter class="labelMargtop">


              <md-layout md-flex="35">
                <label>Assignment No.</label>

                <b-form-input :formatter="capitalizeAll" v-model="mainPageModal.airImportSeries" disabled />
              </md-layout>
            </md-layout>

            <b-card class="mt-3" style="background:whiteSmoke">
              <md-layout md-gutter class="labelMargtop">

                <md-layout md-flex="20">
                  <label for="ffAirMultiBlId">HAWBL No.</label>
                  <model-list-select option-value="ffAirMultiBlId" option-text="secondBLNumber" :list="HAWBLNoList"
                    placeholder="Select HAWBL No." v-model="docModal.ffAirMultiBlId"></model-list-select>
                  <span class="error" v-if="!docModal.ffAirMultiBlId">{{errorDocModal.ffAirMultiBlId}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label for="trackingDoc">Document</label>
                  <model-list-select option-value="trackingDocVal" option-text="trackingDocText" :list="trackingDocList"
                    placeholder="Select Document " v-model="docModal.trackingDoc"></model-list-select>
                  <span class="error" v-if="!docModal.trackingDoc">{{errorDocModal.trackingDoc}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-input-container>
                    <label>Upload Document</label>

                    <md-file name="trackDocUpload" id="trackDocUpload" v-model="docModal.trackDocUpload"
                      @selected="onFileChangetracking" multiple></md-file>
                  </md-input-container>
                  <span class="error" v-if="!docModal.trackDocUpload">{{errorDocModal.trackDocUpload}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Receiving Date</label>
                  <date-picker :format="selectDateFormat" lang="en" id="receivingDate" name="receivingDate"
                    v-model="docModal.receivingDate"></date-picker>
                  <span class="error" v-if="!docModal.receivingDate">{{errorDocModal.receivingDate}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="5">
                  <b-button style="margin-top:35px" variant="info" size="sm" id="addButtonLoader1"
                    @click="uploadMultipleDoc">Upload</b-button>
                  <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
                </md-layout>
              </md-layout>


              <div class="mt-3" v-if="docTableData.length>0">
                <h5>
                  <b-badge>Document Details</b-badge>
                </h5>


                <!-- /.box-header -->
                <div class="box-body">
                  <table id="ffBookingTentative" class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>HAWBL No.</th>
                        <th>Document</th>
                        <th>Receiving Date</th>

                        <th>View Doc</th>
                        <!--  <th>Delete</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in docTableData" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{item.HAWBLNo }}</td>
                        <td>{{item.trackingDoc }}</td>
                        <td>{{item.receivingDate | moment }}</td>

                        <md-button class="md-icon-button md-raised md-dense" @click="viewDoc(item.trackDocUpload)">
                          <md-icon>visibility</md-icon>
                        </md-button>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>
            </b-card>

            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="20"
                v-if="(mainPageModal.containerInfo=='Consolidation' ||(mainPageModal.PODLocationId==mainPageModal.finalPlaceLocationId))">
                <label>Date of Arrival(Airport)</label>
                <date-picker :format="selectDateFormat" lang="en" id="arivalDatePort" name="arivalDatePort"
                  v-model="BookingShippingLine.arivalDatePort"></date-picker>
              </md-layout>
              <md-layout md-flex="20"
                v-if="(mainPageModal.containerInfo=='Normal' &&(mainPageModal.PODLocationId!=mainPageModal.finalPlaceLocationId))">
                <label>Date of Delivery(At Door)</label>
                <date-picker :format="selectDateFormat" lang="en" id="deliveryDateDoor" name="deliveryDateDoor"
                  v-model="BookingShippingLine.deliveryDateDoor"></date-picker>
              </md-layout>
            </md-layout>

            <md-layout gutter v-for="(item,index) in multiHAWBL" :key="index" class="labelMargtop">


              <md-layout md-flex="30">
                <label>HAWBL No.</label>

                <b-form-input :formatter="capitalizeAll" :value="item.secondBLNumber" disabled />
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="30" v-if="mainPageModal.containerInfo=='Consolidation'">
                <label>Delivery Mode</label>

                <b-form-input :formatter="capitalizeAll"
                  :value="item.houseDeliveryMode=='upto_AirPort'?'Upto AirPort':item.houseDeliveryMode" disabled />
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20" v-if="mainPageModal.containerInfo=='Consolidation'">
                <label>Final Delivery Date</label>

                <date-picker :format="selectDateFormat" lang="en" id="HAWBDate" name="HAWBDate"
                  v-model="finalCargoDeliveryDate[index]"></date-picker>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop" v-if="mainPageModal.containerInfo!='Consolidation'">

              <md-layout md-flex="20">
                <label>Actual Date of Arrival(Airport)</label>
                <date-picker :format="selectDateFormat" lang="en" id="actualDatePort" name="actualDatePort"
                  v-model="BookingShippingLine.actualDatePort"></date-picker>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">

              <md-layout md-flex="30">
                <b-button class="mt-3" variant="primary" id="addButtonLoader1" @click="addTrack">Save &
                  Submit</b-button>
                <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop2"
      @close="onCloseProceed"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPopAddTracking"
      @close="onCloseAddTracking"></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import CustomLoader from "../common/customLoader.vue";

import { quillEditor } from "vue-quill-editor";
import { FormInput } from "bootstrap-vue";
import { FormFile } from "bootstrap-vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airImport/airImportTracking");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
    // this.vehicle();
  },
  beforeDestroy() {},
  data() {
    return {
      selectDateFormat,
      types: [
        "text",
        "password",
        "email",
        "number",
        "url",
        "tel",
        "date",
        `time`,
        "range",
        "color"
      ],
      docURL: URL_BASE_DOC,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,
      trackingDocList: [
        {
          trackingDocVal: "CoO",
          trackingDocText: "CoO"
        },
        {
          trackingDocVal: "Invoice",
          trackingDocText: "Invoice"
        },
        {
          trackingDocVal: "PackingList",
          trackingDocText: "Packing List"
        },
        {
          trackingDocVal: "BIS",
          trackingDocText: "BIS"
        },
        {
          trackingDocVal: "Bill_Of_Entry",
          trackingDocText: "Bill Of Entry"
        },
        {
          trackingDocVal: "Pridel_Invoice",
          trackingDocText: "Pridel Invoice"
        },
        {
          trackingDocVal: "Factory_Destuffing_Bond",
          trackingDocText: "Factory Destuffing Bond"
        },
        {
          trackingDocVal: "Overseas_Agent_Invoice",
          trackingDocText: "Overseas Agent Invoice"
        },
        {
          trackingDocVal: "Line_DO",
          trackingDocText: "Line DO"
        },
        {
          trackingDocVal: "Offloading_Letter",
          trackingDocText: "Offloading Letter"
        },
        {
          trackingDocVal: "OtherDoc",
          trackingDocText: "Other Document"
        }
      ],

      value12: "",
      getCLientData: ["gfdg"],
      getHAWBLData: ["gfdg"],
      multiHAWBL: [],
      finalCargoDeliveryDate: [],

      BookingShippingLine: {
        airImportTrackId: "",
        ffairImportId: this.$sessionsStorage.get("editffAirImportId"),
        finalCargoDeliveryDate: "",

        arivalDatePort: "",
        actualDatePort: "",
        deliveryDateDoor: "",
        fclOrLcl: ""
      },
      docModal: {
        ffairImportId: this.$sessionsStorage.get("editffAirImportId"),
        airImportTrackId: "",
        airdocId: "",
        trackingDoc: "",
        trackDocUpload: "",
        receivingDate: "",
        ffAirMultiBlId: "",
        HAWBLNo: ""
      },
      execError: [
        "Select Transhipment",
        "Select IGM Filing Date",
        "Select From Port",
        "Select To Port",
        "Select ETD Date",
        "Select ETA Date",
        "Enter Flight No"
      ],
      errorBookingShippingLine: {
        bookingShipment: "",
        igmFilingDate: "",
        fromPort: "",
        toPort: "",
        etdFromPort: "",
        etaToPort: "",
        flightNo: ""
      },

      //  tentativePortNameFull: {},
      portMasterList: [],
      docTableData: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      mainPageModal: {
        PODLocationId: "",
        finalPlaceLocationId: "",
        firstBlType: "",
        secondBlType: "",
        firstBLRadio: "",
        containerInfo: "",
        airImportSeries: ""
      },
      errorDo: [
        "Select HAWBL No.",
        "Select Document",
        "Upload Document",
        "Select Receiving Date"
      ],
      errorDocModal: {
        ffAirMultiBlId: "",
        trackingDoc: "",
        trackDocUpload: "",
        receivingDate: ""
      },

      HAWBArray: [],
      agentMasterList: [],
      deleteId: "",
      validate: true,
      validateTrans: true,
      arrayErrorAirport: [
        "Select From Port",
        "Select To Port",

        "Select ETA Date",
        "Enter Flight No"
      ],
      errorAirport: {
        fromPort: "",
        toPort: "",

        etaToPort: "",
        flightNo: ""
      },
      showAddAirport: false,

      editIndex: ""
    };
  },

  mounted() {},
  watch: {
    docModal: {
      handler: function(newVal, oldVal) {
        console.log("Here Change obj", newVal, oldVal);

        if (this.docModal.ffAirMultiBlId != "") {
          let arrayHAWBLId = this.multiHAWBL.filter(x => {
            return x.ffAirMultiBlId == this.docModal.ffAirMultiBlId;
          });

          if (arrayHAWBLId.length > 0) {
            this.docModal.HAWBLNo = arrayHAWBLId[0].secondBLNumber;
          }
        }
      },

      deep: true
    }
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    VueTrix,
    quillEditor,
    FormInput,
    CustomLoader,
    FormFile
  },
  computed: {
    HAWBLNoList() {
      return this.multiHAWBL;
    },

    trackingUploadView() {
      return this.docModal.trackDocUpload != ""
        ? this.docModal.trackDocUpload.split(",")
        : [];
    },

    portList() {
      return this.portMasterList;
    },

    bookingShipmentList() {
      return this.bookingShipmentName;
    }
  },
  methods: {
    viewDoc(id) {
      // `${this.docURL}/AirImportTracking/` + id

      window.open("https://uploadsp.pridel.com/FF_Air_Import_Uploads/" + id);
    },
    doLoading() {
      this.isLoading = true;
    },
    uploadMultipleDoc() {
      this.validateUploadDoc();
      if (this.validate != false) {
        let newData = {
          docModal: this.docModal,
          normalTrackingModal: this.BookingShippingLine,
          onlyExecMain: ""
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirImport/addTrackingAirImp.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              console.log(data);
              this.BookingShippingLine.airImportTrackId = data.airImportTrackId;
              this.$sessionsStorage.set(
                "editAirTrackId",
                data.airImportTrackId
              );

              Object.keys(this.docModal).map(x => {
                this.docModal[x] = "";
              });
              Object.keys(this.errorDocModal).map(x => {
                this.errorDocModal[x] = "";
              });

              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    validateUploadDoc() {
      let validate_new = true;
      Object.keys(this.errorDocModal).map((x, index) => {
        if (this.docModal[x] == "") {
          this.errorDocModal[x] = this.errorDo[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      //   let minuteNew = [Hour, minute].join(":");

      return dateNew;
    },
    addTrack() {
      // this.BookingShippingLine["transhipmentDetail"] = this.docTableData;

      this.BookingShippingLine["finalCargoDeliveryDate"] = "";
      this.finalCargoDeliveryDate.map(x => {
        this.BookingShippingLine["finalCargoDeliveryDate"] +=
          this.formatDate(x) + ",";
      });

      this.BookingShippingLine["ffairImportId"] = this.$sessionsStorage.get(
        "editffAirImportId"
      );
      //  this.validateExec();

      $("#addButtonLoaderSub").css("display", "none");
      $("#loaderSub").css("display", "block");

      let newData = {
        docModal: this.docModal,
        normalTrackingModal: this.BookingShippingLine,
        onlyExecMain: "dsadsad"
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirImport/addTrackingAirImp.php`,
        data: JSON.stringify(newData),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            $("#loaderSub").css("display", "none");
            $("#addButtonLoaderSub").css("display", "block");

            if (this.BookingShippingLine.airImportTrackId == "") {
              this.alert.content = "Data Added Successfully";
            } else {
              this.alert.content = "Data Updated Successfully";
            }
            this.BookingShippingLine.airImportTrackId = data.airImportTrackId;
            this.$sessionsStorage.set("editAirTrackId", data.airImportTrackId);

            this.$refs["addPopAddTracking"].open();
            this.getData();
          }
        })
        .catch(error => {});
    },

    onCloseAddTracking() {},

    onFileChangetracking() {

       let files = event.target.files || event.dataTransfer.files;

      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "moduleId",
          this.$sessionsStorage.get("editffAirImportId")
        );

        formData.append("staticFileName", "Air_Import_TrackingDoc");

        formData.append("upload_dir_folderName", "FF_Air_Import_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then(result => {
          this.docModal.trackDocUpload = result.data;
        })
        .catch(err => {
          throw err;
        });


     
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onCloseProceed() {
      // this.$router.push({
      //   path: "/seaImport/seaImportNormalTrack"
      // });
    },
    onClose6(type) {},

    viewEdit(item, index) {
      this.showAddAirport = true;
      Object.keys(this.moreAirportModel).map(x => {
        this.moreAirportModel[x] = item[x];
      });
    },
    DeleteList(item, index) {
      this.deleteId = item.moreAirportId;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    previousAir() {
      this.$router.push({
        path: "/airImport/airImportExec"
      });
    },

    validateExec() {
      let validate_new = true;

      Object.keys(this.errorBookingShippingLine).map((x, index) => {
        if (this.BookingShippingLine[x] == "") {
          this.errorBookingShippingLine[x] = this.execError[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffBookingTentative").DataTable();
    //   });
    // },
    getData() {
      this.doLoading();

      let new_data = {
        ffairImportId: this.$sessionsStorage.get("editffAirImportId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirImport/fetchToAirImportTrack.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            console.log(data);

            if (data.airImportData.length > 0) {
              Object.keys(this.mainPageModal).map(x => {
                this.mainPageModal[x] = data.airImportData[0][x] || "";
              });
              this.BookingShippingLine.fclOrLcl =
                data.airImportData[0].containerInfo;
            }
            if (data.AirImportTrackData.length > 0) {
              Object.keys(this.BookingShippingLine).map(x => {
                if (x == "finalCargoDeliveryDate") {
                  this.finalCargoDeliveryDate = data.AirImportTrackData[0][
                    x
                  ].split(",");
                }
                this.BookingShippingLine[x] =
                  data.AirImportTrackData[0][x] || "";
              });
            }
            if (data.airImportMultiHouseData.length > 0) {
              this.multiHAWBL = data.airImportMultiHouseData;
            }
            if (data.AirTrackMultipleDoc.length > 0) {
              this.docTableData = data.AirTrackMultipleDoc;
            }

            this.doLoadingClose();
            //   this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// airImportTracking.vue?5e60e50a